// extracted by mini-css-extract-plugin
module.exports = {"button":"_2lX2Zs","container":"_39Ii3X","icon":"_1TBpLr","menuLabel":"_6Lhxud"};